module.exports = __webpack_public_path__ + "static/img/288_TO8_2450_og.24e6504.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/288_TO8_2450_og.jpg
// module id = pbaI
// module chunks = 0